"use strict";

define('rs/models/document.decision',['rs/models/abstract', 'rs/models/person', 'moment'], function (RSAbstractModel, Person, moment) {
  var Decision = RSAbstractModel.extend({
    properties: ['id', 'document', 'displayResultDate', 'displayExpirationDate', 'children', 'responsiblePerson'],
    serverProperties: ['activityDate', 'decisionType', 'expirationDate', 'finalizedDate', 'findings', 'internalNotes', 'recused', 'researchNotes', 'resultDate', 'type', 'updateUserAuthId', 'version', 'voteAbstain', 'voteAgainst', 'voteFor', 'parentId', 'categories'],
    initialize: function initialize() {
      this.listenTo(this, 'change:finalizedDate', this.finalizedDateDidChange);
      this._super.apply(this, arguments);
      this.initializeChildren();
      if (!this.getVoteAbstain()) {
        this.setVoteAbstain(0);
      }
      if (!this.getVoteAgainst()) {
        this.setVoteAgainst(0);
      }
      if (!this.getVoteFor()) {
        this.setVoteFor(0);
      }
      if (this.getDocument()) {
        this.setDocument(Decision.Document.model(this.getDocument()));
      }
      if (this.getResponsiblePerson()) {
        this.setResponsiblePerson(Person.model(this.getResponsiblePerson()));
      }
      this.listenTo(this, 'change:resultDate', this.refreshDateDisplayFields);
      this.listenTo(this, 'change:expirationDate', this.refreshDateDisplayFields);
      this.refreshDateDisplayFields();
    },
    getDecisionByResponsiblePersonId: function getDecisionByResponsiblePersonId(personId) {
      var res = [];
      function recurse(root) {
        for (var i = 0, len = root.children.length; i < len; i++) {
          recurse(root.children[i]);
        }
        if (root.getResponsiblePerson() && root.getResponsiblePerson().id == personId) {
          res.push(root);
        }
      }
      recurse(this);
      if (res && res.length) {
        return res[0];
      }
      return null;
    },
    initializeChildren: function initializeChildren() {
      var children = this.getChildren() || [];
      for (var i = 0, len = children.length; i < len; i++) {
        if (!(children[i] instanceof Decision)) {
          children[i] = new Decision(children[i]);
        }
      }
      this.setChildren(children);
    },
    finalizedDateDidChange: function finalizedDateDidChange() {
      this.finalized = this.getFinalizedDate() != null && this.getDecisionType();
    },
    getDocumentId: function getDocumentId() {
      var doc = this.getDocument();
      return doc ? doc.id : null;
    },
    setDecisionTypeId: function setDecisionTypeId(id) {
      id = parseInt(id);
      if (_.isNaN(id)) {
        this.setDecisionType(null);
      } else {
        this.setDecisionType({
          id: id
        });
      }
    },
    requestPromote: function requestPromote() {
      this.constructor.requestPromote(this.getId());
    },
    getDecisionTypeId: function getDecisionTypeId() {
      var type = this.getDecisionType();
      return type ? type.id : null;
    },
    refreshDateDisplayFields: function refreshDateDisplayFields() {
      var displayResultDate = this.getResultDate(),
        displayExpirationDate = this.getExpirationDate();
      if (displayResultDate) {
        displayResultDate = moment(displayResultDate).format('L');
      }
      if (displayExpirationDate) {
        displayExpirationDate = moment(displayExpirationDate).format('L');
      }
      this.setDisplayResultDate(displayResultDate);
      this.setDisplayExpirationDate(displayExpirationDate);
    },
    requestUpdate: function requestUpdate() {
      var that = this;
      return this.constructor.requestUpdate(this.getId(), this).then(function (data) {
        that.updateWithServerProperties(data);
        return that;
      });
    },
    requestTypes: function requestTypes() {
      return this.constructor.requestTypes(this.getDocumentId());
      ;
    },
    getDecisionTypeDescription: function getDecisionTypeDescription() {
      return this.get('decisionType.description');
    },
    toJSON: function toJSON() {
      var json = this._super(),
        typeId = this.getDecisionTypeId();
      json.document = {
        id: this.getDocumentId()
      };
      if (typeId != null) {
        json.decisionType = {
          id: typeId
        };
      }
      return json;
    }
  }, {
    rootURI: '/rs/api/',
    parsers: {
      '#GET#decision/:id': function GETDecision_Id(data) {
        var decision = this.model(data);
        return decision;
      },
      'decision/open/:id': function decision_open_Id(data) {
        return this.models(data);
      },
      '#GET#decision/document/:id': function GETDecision_document_Id(data) {
        return this.models(data);
      },
      'decision/expedited/:meetingId': function decision_expedited_MeetingId(data) {
        return this.models(data);
      }
    },
    requestOne: function requestOne(decisionId) {
      return this.get('decision/' + decisionId);
    },
    requestOpenDecisionsByDocumentId: function requestOpenDecisionsByDocumentId(documentId) {
      return this.get('decision/open/' + documentId);
    },
    requestAllByDocumentId: function requestAllByDocumentId(documentId) {
      return this.get('decision/document/' + documentId);
    },
    requestUpdate: function requestUpdate(id, data) {
      return this.put('decision/' + id, data, {
        jsonBody: true
      });
    },
    requestPromote: function requestPromote(id) {
      return this.post('decision/promote/' + id);
    },
    requestAllTypes: function requestAllTypes() {
      return this.get('decision/types');
    },
    requestTypes: function requestTypes(documentId) {
      return this.get('decision/types/' + encodeURIComponent(documentId));
    },
    requestExpedited: function requestExpedited(meetingId) {
      return this.get('decision/expedited/' + encodeURIComponent(meetingId));
    },
    requestExempt: function requestExempt(meetingId) {
      return this.get('decision/exempt/' + encodeURIComponent(meetingId));
    }
  });
  return Decision;
});

